import React, { useEffect, useState } from "react";
import InputForm from "../../../Components/InputForm/InputForm";
import { getKycId } from "../../../Helpers/APIEndPoints/EndPoints";
import { APICall } from "../../../Helpers/Network/APICalls";
import "./KYCDetails.css";
import { useLocation } from "react-router-dom";
import { downloadBlob } from "../../../Helpers/Common/BlobHelper";
import { BsImage } from "react-icons/bs";
import { Tooltip } from "@mui/material";
import ImageViewer from "../../../Components/ImageViewer/ImageViewer";
import { GetDecryptedMemberIdFromLocalStorage } from "../../../Helpers/CommonFunctions/EncryptedMemberIdFunction";

const KYCDetails = (props) => {
  const { state } = useLocation();
  const [data, setData] = useState({
    accholderName: "",
    bankName: "",
    ifscCode: "",
    accountNumber: null,
    aadharNo: null,
    panNo: null,
    confirmAccountNo: null,
    emailId: "",
    // panName:null,
    mobileNumber: null,
    uploadCheque: null,
    micrCode: null,
    uploadPan: null,
    // chqName:null,
    statusId: null,
    statusName: null,
    rejectedRemarks: [],
  });
  const [disabled, setDisabled] = useState(true);
  const [panName, setPanName] = useState(null);
  const [chqName, setchqName] = useState(null);
  const [showImageViewer, setShowImageViewer] = useState<boolean>(false);
  // const memberid =
  //   GetDecryptedMemberIdFromLocalStorage() || state?.MemberId || "";
  
  const memberid = state.id ? state.id : "";
  const [images, setImages] = useState([]);
  const [imageIndex, setImageIndex] = useState<number>(null);

  useEffect(() => {
    getKYCDetails();
  }, []);

  useEffect(() => {
    if (imageIndex !== null) {
      setShowImageViewer(true);
    }
  }, [imageIndex]);

  useEffect(() => {
    if (!showImageViewer) {
      setImageIndex(null);
    }
  }, [showImageViewer]);

  const getKYCDetails = async () => {
    let url = `${getKycId}`;
    let requestBody = { MemberId: memberid };

    const getData = await APICall(url, requestBody);
  
    if (getData.Data != null) {
      let obj = {
        accholderName: getData.Data.AccountHolderName,
        bankName: getData.Data.BankName,
        ifscCode: getData.Data.IFSCCode,
        accountNumber: getData.Data.AccountNo,
        aadharNo: getData.Data.AadharNo,
        panNo: getData.Data.PANNo,
        confirmAccountNo: getData.Data.ConfirmAccountNo,
        emailId: getData.Data.EmailId,

        mobileNumber: getData.Data.RegisteredMobilNo,
        uploadCheque: null,
        micrCode: getData.Data.MICRCode,
        uploadPan: null,
        statusId: getData.Data.StatusId,
        statusName: getData.Data.StatusName,
        rejectedRemarks: getData?.Data?.RejectedRemarks?.split("\n") || [],
      };
      setData(obj);
      setchqName(getData.Data.CheckdocName);
      setPanName(getData.Data.PandocName);

      let imgs = [getData?.Data?.PandocUrl, getData?.Data?.CheckdocUrl];

      let newImages = [];
      for (let index = 0; index < imgs.length; index++) {
        const img = imgs[index];
        let imgUrl = await downloadBlob(img);
        newImages.push({
          src: imgUrl,
          title:
            (index === 1 ? "Cancelled cheque of " : "PAN of ") +
            getData?.Data?.AccountHolderName,
        });
      }
      setImages(newImages);
    }
    return getData.Data;
  };

  return (
    <div className="">
      <div className="col-lg-12 col-md-12 p-0">
        <div className="row">
          <div
            className="col-lg-4 col-sm-4 col-xs-4 "
            style={{ marginTop: "15px" }}
          >
            <div className="form-group">
              <label>Account Holder Name</label>
              <InputForm
                placeholder={""}
                value={data.accholderName}
                maxlength={30}
                isDisabled={disabled}
                type="text"
              />
            </div>
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>Bank Name</label>
            <InputForm
              placeholder={""}
              maxlength={30}
              value={data.bankName}
              type="text"
              isDisabled={disabled}
            />
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>IFSC Code</label>
            <InputForm
              placeholder={""}
              maxlength={11}
              value={data.ifscCode}
              type="text"
              isDisabled={disabled}
            />
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>Account Number</label>
            <InputForm
              placeholder={""}
              maxlength={20}
              value={data.accountNumber}
              type="number"
              isDisabled={disabled}
              onWheel={(e) => e.target.blur()}
            />
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>Aadhaar No</label>
            <InputForm
              placeholder={""}
              maxlength={12}
              value={data.aadharNo}
              type="number"
              isDisabled={disabled}
              onWheel={(e) => e.target.blur()}
            />
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>PAN No</label>
            <InputForm
              placeholder={""}
              maxlength={10}
              value={data.panNo}
              type="text"
              isDisabled={disabled}
            />
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>Confirm Account Number</label>
            <InputForm
              placeholder={""}
              maxlength={20}
              value={data.confirmAccountNo}
              type="number"
              isDisabled={disabled}
              onWheel={(e) => e.target.blur()}
            />
          </div>

          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>Email Id</label>
            <InputForm
              placeholder={""}
              value={data.emailId}
              type="text"
              isDisabled={disabled}
            />
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>PAN No</label>
            <label
              className="form-control pe-pointer"
              style={{ border: "none" }}
              onClick={() => setImageIndex(0)}
            >
              <Tooltip title="Click to view image">
                <div className="d-inline-block">
                  <BsImage color="#DB233A" className="mr-2" />
                  <span>{panName}</span>
                </div>
              </Tooltip>
            </label>
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>Registered Mobile number Linked to Bank account</label>
            <InputForm
              placeholder={""}
              maxlength={10}
              value={data.mobileNumber}
              type="number"
              isDisabled={disabled}
              onWheel={(e) => e.target.blur()}
            />
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>Cheque No</label>
            <label
              className="form-control pe-pointer"
              style={{ border: "none" }}
              onClick={() => setImageIndex(1)}
            >
              <Tooltip title="Click to view image">
                <div className="d-inline-block">
                  <BsImage color="#DB233A" className="mr-2" />
                  <span>{chqName}</span>
                </div>
              </Tooltip>
            </label>
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>MICR Code</label>
            <InputForm
              placeholder={""}
              maxlength={9}
              value={data.micrCode}
              type="number"
              isDisabled={disabled}
              onWheel={(e) => e.target.blur()}
            />
          </div>
        </div>
      </div>

      <ImageViewer
        open={showImageViewer}
        images={images}
        imageIndex={imageIndex}
        onClose={() => setShowImageViewer(false)}
      />
    </div>
  );
};

export default KYCDetails;
